const systems = {
	other: 'other',
	target_mail: 'target_mail',
	novostnik: 'novostnik'
};

const locale = {
	ru: {
		other: 'Прочее',
		target_mail: 'MyTarget',
		novostnik: 'Новостная витрина'
	},
	uk: {
		other: 'Інше',
		target_mail: 'MyTarget',
		novostnik: 'Новинна вітрина'
	},
	en: {
		other: 'Other',
		target_mail: 'MyTarget',
		novostnik: 'News parking'
	},
	de: {
		other: 'Other',
		target_mail: 'MyTarget',
		novostnik: 'News parking'
	},
	vi: {
		other: 'Other',
		target_mail: 'MyTarget',
		novostnik: 'News parking'
	},
	th: {
		other: 'อื่นๆ',
		target_mail: 'MyTarget',
		novostnik: 'กระดานข่าว'
	}
};

module.exports = {
	enum: systems,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/adv-systems.js